import React from 'react'
import { Helmet } from 'react-helmet-async'

export default function PageMeta({ title, description }) {
  const defaultTitle = "Sakskær Auto"
  const finalTitle = title ? (title.includes("Sakskær Auto") ? title : `${title} - Sakskær Auto`) : defaultTitle

  return (
    <Helmet>
      <title>{finalTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={finalTitle} />
      {description && <meta property="og:description" content={description} />}
      <html lang="da" />
    </Helmet>
  )
}
